import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { ErrorRecord, IFormField } from "cayo.ui";
import { IJsonForm } from "@cayo/shared/api/types/schema";
import modelUtils from "../modelUtils";
import { getFlatItems } from "../modelUtils/build-model";
import { formUtils } from "../utils";

const useFormErrors = (form: IJsonForm) => {
  const intl = useIntl();
  const [errors, setErrors] = useState<{ [id: string]: ErrorRecord }>({});

  const setErrorCallback = useCallback((name: string, e?: ErrorRecord) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (e?.errorMessage) {
        newErrors[name] = e;
      } else {
        delete newErrors[name];
      }

      return newErrors;
    });
  }, []);

  const countErrors = useCallback(
    (model: any, tabIndex?: number) => {
      let totalErrors = 0;
      if (!form?.items?.length) {
        return totalErrors;
      }

      const items = getFlatItems(form.items, model, tabIndex);
      const editableItems = modelUtils.getEditableItems(items as IFormField[], model);

      for (const a of editableItems) {
        const name = (a as any).modelProperty || a.name;
        const hasError = formUtils.checkError(a, model[name!], setErrorCallback, intl);
        totalErrors += hasError ? 1 : 0;
      }

      return totalErrors;
    },
    [form]
  );

  return { errors, setErrors, setErrorCallback, countErrors, clearErrors: () => setErrors({}) };
};

export default useFormErrors;
